import type { DateTime } from 'luxon';
import type { ILeg } from '../../../models/pa-egna-ben/leg.model';
import type IParticipation from '../../../models/pa-egna-ben/participation.model';
import type IMunicipalityAdministratorParticipation from '../MunicipalityAdministrator/components/Municipality/models/participation-list-entry.view-model';

export enum LegReportStatus {
  missed = 'missed',
  open = 'open',
  notOpen = 'notopen',
  earilerOpenLegExists = 'earileropenlegexists',
  qualificationLimitReached = 'qualificationlimitreached',
  qualificationLimitNotReached = 'qualificationlimitnotreached',
}

export class ParticipationHelper {
  public static getLegReportStatus(participation: IParticipation, leg: ILeg, timestamp: DateTime): LegReportStatus {
    const legReport = participation.legReports.find((lr) => lr.legId === leg.id);
    if (legReport) {
      // NV-8926: This legacy comparison uses unweighted points. RegisterScore treats both outcomes as already reported; neither is shown as a qualification result.
      return legReport.score >= leg.qualificationLimit ? LegReportStatus.qualificationLimitReached : LegReportStatus.qualificationLimitNotReached;
    }
    if (timestamp > leg.endTime) {
      return LegReportStatus.missed;
    }
    if (timestamp < leg.startTime) {
      return LegReportStatus.notOpen;
    }
    // Check that no previous open, unreported legs exists
    const openLegs = participation.competition?.legs.filter((l) => l.startTime <= timestamp && l.endTime >= timestamp);
    const reportedLegIds = participation.legReports.map((lr) => lr.legId);
    const reportedLegs = participation.competition?.legs.filter((l) => reportedLegIds.includes(l.id));
    if (openLegs?.filter((ol) => !reportedLegs?.includes(ol)).some((ol) => ol.number < leg.number)) {
      return LegReportStatus.earilerOpenLegExists;
    }
    return LegReportStatus.open;
  }

  public static getFullName(participation: IParticipation | undefined): string {
    return `${participation?.name} ${participation?.school?.name}`;
  }

  public static getCurrentLeg(participation: IParticipation, timestamp: DateTime): ILeg | undefined {
    return participation.competition?.legs.find((l) => l.startTime <= timestamp && l.endTime >= timestamp);
  }

  public static missingLegScore(item: IMunicipalityAdministratorParticipation, anyLegIsActive: boolean): boolean {
    return (!item.latestFinishedLegReportWeightedScore || item.latestFinishedLegReportWeightedScore <= 0) && anyLegIsActive;
  }

  // public static getNextOpenLegToReport(participation: IParticipation, timestamp: DateTime): ILeg | undefined {
  //   const openLegs = participation.competition.legs
  //     .filter((l) => ParticipationHelper.getLegReportStatus(participation, l, timestamp) === LegReportStatus.open)
  //     .filter((l) => !participation.legReports.some((lr) => lr.legId === l.id))
  //     .sort((a, b) => (a.startTime < b.startTime ? -1 : 1));
  //   if (openLegs.length === 0) {
  //     return undefined;
  //   }
  //   return openLegs[0];
  // }
}

